package com.wintermar.inspection.feature.presentation.inspection.answer.widget.header

import androidx.compose.runtime.Composable
import com.wintermar.inspection.core.ui.component.connectivity_monitor.util.ConnectivityMonitorStatus
import com.wintermar.inspection.core.ui.theme.AppDimension
import com.wintermar.inspection.core.ui.theme.color.model.ThemeColor

@Composable
actual fun Header(
    templateName: String,
    connectivityMonitorStatus: ConnectivityMonitorStatus,
    color: ThemeColor,
    dimension: AppDimension,
    onClose: () -> Unit,
    onSaveProgress: () -> Unit,
    onSearch: () -> Unit
) {
    HeaderWide(
        templateName = templateName,
        color = color,
        dimension = dimension,
        onClose = onClose,
        onSaveProgress = onSaveProgress,
        onSearch = onSearch
    )
}
